import { JSX } from "react";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import { IndividualControlLayoutProps } from "@plansoft-configuration-renderer/components";

export function IndividualComponent(
  props: IndividualControlLayoutProps,
): JSX.Element {
  const { variant = "variantFallback", custom = {} } = props;
  return (
    <Box my={2}>
      <Alert>
        <AlertTitle>{variant}</AlertTitle>
        <code>{JSON.stringify(custom, null, 2)}</code>
      </Alert>
    </Box>
  );
}
